export default "__VITE_ASSET__df85a8e7__"